import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "exchange-page" }
const _hoisted_2 = { class: "page-scroll-wrap" }
const _hoisted_3 = { class: "exchange-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "diamond-wrap flex justify-center" }
const _hoisted_6 = { class: "exchange-price" }

import { ref, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useAccountStore } from "@/store";
import { queryBetMall, mallExchange } from "@/api";


export default {
  __name: 'exchange',
  setup(__props) {

const MyToast = inject('myToast');

const { t } = useI18n()

const accountStore = useAccountStore();
const { point } = storeToRefs(accountStore);
const dataList = ref([]);
const activeItem = ref(null);
  
onMounted(() => {
  fetchBetMall();
})


const fetchBetMall = () => {
  queryBetMall().then(res => {
    dataList.value = res.data || [];
  })
}
const doExchange = () => {
  mallExchange({
    gid: activeItem.value.gid
  }).then(res => {
    activeItem.value = null;
    accountStore.fetchBalance();
    MyToast({ type: 'success', message: t('notify.operateSuccess') });
  })
}

return (_ctx, _cache) => {
  const _component_HeaderBar = _resolveComponent("HeaderBar")
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_button = _resolveComponent("van-button")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderBar),
    _createVNode(_component_NavBar, {
      title: _ctx.$t('finance.type.exchange')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, (item) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(`exchange-item ${item.id === activeItem.value?.id ? 'active' : ''}`),
            key: item.id,
            onClick: $event => (activeItem.value = item)
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_van_image, {
                class: "diamond-img",
                src: require('@/assets/img/finance/diamond.png')
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.price) + " = P" + _toDisplayString(item.bonus), 1),
            _createVNode(_component_van_image, {
              class: "coin-img",
              src: item.picture
            }, null, 8, ["src"])
          ], 10, _hoisted_4)), [
            [_directive_audio]
          ])
        }), 128))
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_van_button, {
        class: "exchange-btn",
        disabled: !activeItem.value || activeItem.value.price > _unref(point),
        onClick: doExchange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.exchange')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])), [
        [_directive_audio]
      ])
    ])
  ]))
}
}

}